import Vue from 'vue'

export default {
  ADD_NEW_AGENCY (state, agency) {
    state.agencies = state.agencies.filter(c => !c.isNew)
    state.agencies.push(agency)
    state.agency = agency
  },
  ADD_AGENCY (state, agency) {
    state.agency = agency
  },
  DELETE_AGENCY (state, id) {
    state.agencies = state.agencies.filter(a => a.id !== id)
    if (state.agencies[0]) {
      state.agency = state.agencies[0]
    }
  },
  ADD_AGENCIES (state, agencies) {
    state.agencies = agencies
  },
  ADD_ANNOUNCEMENT (state, agency) {
    state.agency = agency
  },
  UPDATE_AGENCIES (state, agencies) {
    state.agencies = agencies
  },
  UPDATE_AGENCY (state, agency) {
    state.agency = agency
  },
  DELETE_ANNOUNCEMENT (state, agency) {
    state.agency = agency
  },
  LOAD_AGENCY_PHOTO (state, agency) {
    state.agency.photo = agency.photo
  },
  ADD_CONSULTANT (state, consultant) {
    state.agency.consultants.push(consultant)
  },
  DELETE_CONSULTANT (state, id) {
    state.agency.consultants = state.agency.consultants.filter((c) => {
      return c.id !== id
    })
  },
  UPDATE_CONSULTANT (state, consultant) {
    Object.assign(state.agency.consultants.find(c => c.id === consultant.id), consultant)
  },
  CHANGE_CONSULTANT_PHOTO (state, consultant) {
    let c = state.agency.consultants.find(c => c.id === consultant.id)
    c.photo = consultant.photo
  },
  UPDATE_AGENCY_CONSULTANT_PHOTO (state, photoData) {
    let c = state.agency.consultants.find(c => c.id === photoData.id)
    Vue.set(c, 'photo', photoData)
  },
  DELETE_CONSULTANT_PHOTO (state, id) {
    let c = state.agency.consultants.find(c => c.id === id)
    Vue.set(c, 'photo', null)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/about.js